import React from 'react';

export function TaskDelete() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_2623_6015)">
                <path
                    d="M1.94391 4.6875L2.77419 14.7105C2.83369 15.4333 3.44938 16 4.17494 16H11.8251C12.5507 16 13.1663 15.4333 13.2258 14.7105L14.0561 4.6875H1.94391ZM5.65581 14.125C5.41044 14.125 5.204 13.9341 5.18844 13.6855L4.71969 6.12303C4.70366 5.86441 4.90003 5.64194 5.15822 5.62591C5.426 5.60713 5.63888 5.80581 5.65534 6.06444L6.12409 13.6269C6.14069 13.8948 5.92878 14.125 5.65581 14.125ZM8.46875 13.6562C8.46875 13.9153 8.25909 14.125 8 14.125C7.74091 14.125 7.53125 13.9153 7.53125 13.6562V6.09375C7.53125 5.83466 7.74091 5.625 8 5.625C8.25909 5.625 8.46875 5.83466 8.46875 6.09375V13.6562ZM11.2803 6.12306L10.8116 13.6856C10.7962 13.9316 10.5911 14.1367 10.3144 14.1241C10.0563 14.1081 9.85987 13.8856 9.87591 13.627L10.3447 6.06447C10.3607 5.80584 10.5873 5.61769 10.8418 5.62594C11.1 5.64197 11.2963 5.86444 11.2803 6.12306ZM14.0938 1.875H11.2812V1.40625C11.2812 0.630813 10.6504 0 9.875 0H6.125C5.34956 0 4.71875 0.630813 4.71875 1.40625V1.875H1.90625C1.38847 1.875 0.96875 2.29472 0.96875 2.8125C0.96875 3.33022 1.38847 3.75 1.90625 3.75H14.0938C14.6115 3.75 15.0312 3.33022 15.0312 2.8125C15.0312 2.29472 14.6115 1.875 14.0938 1.875ZM10.3438 1.875H5.65625V1.40625C5.65625 1.14762 5.86637 0.9375 6.125 0.9375H9.875C10.1336 0.9375 10.3438 1.14762 10.3438 1.40625V1.875Z"
                    fill="#ADB0B5"
                />
            </g>
            <defs>
                <clipPath id="clip0_2623_6015">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
